import React from 'react'
// import PlacementData from  '../components/PlacementsData'

import HorizontalTabs from '../components/HorizontalTabs';
import { Link } from 'react-router-dom';

function placements() {
  const tabs = [
    { title: 'University Acceptance', content: () => <div>
        
        
     <div className='cam-lower-sec'>
    <h1 className='title'>University Acceptance</h1>
    </div>
     
      <div className='uni-placement-row'>
        <div className='uni-placements'>
          <div className='uni-placemet-img'>
            <Link to=""><img src='../img/placements/university-acceptance/Tisha-Jindal.webp'></img></Link>
          </div>
          <div className='uni-placement-content'>
            <h3> Tisha Jindal</h3>
            <p> University of Toronto</p>
            <p> University of Illinois, Urbana-Champagne</p>
            <p> Purdue University</p>
            <p> Rutgers University</p>
            <p> Texas A&M University </p>
            <p> Arizona State University</p>
            <p> Course- Aerospace Engineering</p>
          </div>
        </div>
        <div className='uni-placements'>
          <div className='uni-placemet-img'>
            <Link to=""><img src='../img/placements/university-acceptance/Ayush-Aggarwal.webp'></img></Link>
          </div>
          <div className='uni-placement-content'>
            <h3>Ayush Aggarwal</h3>
            <p> <b>UK university</b> </p>
            <ol>
              <li>Manchester University</li>
              <li>Cass business school</li>
              <li>University of leeds</li>
              <li>University of exter</li>
            </ol>
            <p> <b>USA university</b> </p>
            <ol>
              <li>Airzona university</li>
              <li>Indiana University Bloomington France EDHEC Business school</li>
            </ol>
          </div>
        </div>
        <div className='uni-placements'>
          <div className='uni-placemet-img'>
            <Link to="">
            <img src='../img/placements/university-acceptance/Sara-Yadav.webp'></img>
            </Link>
          </div>
          <div className='uni-placement-content'>
            <h3>Sara Yadav</h3>
            <p>King’s College London (London, UK)</p>
            <p> University of Manchester (Manchester, UK)</p>
            <p>Queen Mary University (London, UK)</p>
            <p>Royal Holloway University (London, UK)</p>
            <p> University of Reading(Reading, UK)</p>
            <p> Ashoka University (Sonipat, India)</p>
            <p><b>   Under-graduation:</b></p>
            <p>King’s College London (London, UK)</p>
            <p> Course:- English with Film Studies</p>

          </div>
        </div>

        

    

       
   
      </div>
    
  
    </div> },
  
  { title: 'University Placement', content: () => <div>
    
    <div className='cam-lower-sec'>
    <h1 className='title'>University Placement</h1>
    </div>

    <div className='uni-placement-row'>
        <div className='uni-placements'>
          <div className='uni-placemet-img'>
            <Link to=""><img src='../img/placements/university-placement/Lakshay-Pratap-Singh-Shekhawat.webp'></img></Link>
          </div>
          <div className='uni-placement-content'>
            <h3>Lakshay Pratap Singh Shekhawat</h3>
            <p> Les Roches Marbella,Spain</p>
            <p>(BBA in global hospitality management)</p>
          </div>
        </div>
        <div className='uni-placements'>
          <div className='uni-placemet-img'>
            <Link to=""><img src='../img/placements/university-placement/Kavya-Chandra.webp'></img></Link>
          </div>
          <div className='uni-placement-content'>
            <h3>Kavya Chandra</h3>
            <p>Bachelor of Science in Forensic Science and Psychology</p>
            <p>Trent University, Toronto, Canada (4 years)</p>
            <p>University of Kent, London, UK</p>
          </div>
        </div>

        <div className='uni-placements'>
          <div className='uni-placemet-img'>
            <Link to="">
            <img src='../img/placements/university-placement/Vaishali-Sharma.webp'></img>
            </Link>
          </div>
          <div className='uni-placement-content'>
            <h3>Vaishali Sharma</h3>
            <p>Wichita State University</p>
            <p>Mechanical Engineering</p>
          </div>
        </div>
        <div className='uni-placements'>
          <div className='uni-placemet-img'>
            <Link to="">
            <img src='../img/placements/university-placement/Aanya Chandra.webp'></img>
            </Link>
          </div>
          <div className='uni-placement-content'>
            <h3>Aanya Chandra</h3>
            <p>Psychology Honours</p>
            <p>Trent University</p>
            <p>Ontario, Canada</p>
          </div>
        </div>
        <div className='uni-placements'>
          <div className='uni-placemet-img'>
            <Link to="">
            <img src='../img/placements/university-placement/Akshita Swaroop.webp'></img>
            </Link>
          </div>
          <div className='uni-placement-content'>
            <h3>Akshita Swaroop</h3>
            <p>The Smeal College of Business at The Pennsylvania State University Undergraduate</p>
    
          </div>
        </div>
        <div className='uni-placements'>
          <div className='uni-placemet-img'>
            <Link to="">
            <img src='../img/placements/university-placement/Tisha Jindal.webp'></img>
            </Link>
          </div>
          <div className='uni-placement-content'>
            <h3>Tisha Jindal</h3>
            <p>Aerospace Engineering</p>
            <p>Nanyang Technological University</p>
          </div>
        </div>
        <div className='uni-placements'>
          <div className='uni-placemet-img'>
            <Link to="">
            <img src='../img/placements/university-placement/Kunal Soni.webp'></img>
            </Link>
          </div>
          <div className='uni-placement-content'>
            <h3> Kunal Soni</h3>
            <p>Bachelor of Economics</p>
            <p>University of massachusetts Amherst</p>
          </div>
        </div>


      </div>
    
    </div> },
  







  

  ];
  
  return (
    <div>
          <div className='ibdp-hero-sec'>
        <img src='newimg/studentex.webp'/>

      </div>
      
      <div className='placements-sec'>
      <HorizontalTabs tabs={tabs} />
      </div>
      {/* <PlacementData/> */}
    </div>
  )
}

export default placements
